import { DocusealForm } from "@docuseal/react";
import type React from "react";
import type { ComponentProps } from "react";

type DocusealBaseFormProps = ComponentProps<typeof DocusealForm> & {
  isOpen?: boolean;
  onClose?: () => void;
};

export const DocusealBaseForm: React.FC<DocusealBaseFormProps> = (props) => {
  return (
    <DocusealForm
      name={`Sign Agreement - ${props.name}`}
      orderAsOnPage
      autoscrollFields
      withTitle
      allowTypedSignature
      reuseSignature={false}
      expand={false}
      withSendCopyButton={false}
      rememberSignature={false}
      {...props}
    />
  );
};
